import React from "react"
import {
    HorizontalStack,
    IconButton,
    type StyleProps,
} from "@mallardbay/lib-react-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons/faArrowUpFromBracket"
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark"

import WishlistButton from "~components/pages/wishlist/wishlist-button"
import { navigateBackOrHome } from "~utils/navigation-helpers"
import { useCopyOrShare } from "~utils/use-copy-or-share"
import Box from "~components/shared/todo-lib-react-components/box"
import { useTabletMediaQueries } from "~components/shared/todo-lib-react-components/hooks/use-media-queries"

interface Props {
    readonly listingId?: string
}

export default function MobileHeaderButtons({ listingId }: Props) {
    const styles = useStyles()
    const copyOrShare = useCopyOrShare()

    const { isLargerThanTablet } = useTabletMediaQueries()
    if (isLargerThanTablet) return null

    return (
        <Box style={styles.container}>
            <IconButton
                onClick={navigateBackOrHome}
                icon={<FontAwesomeIcon icon={faXmark} />}
            />
            <HorizontalStack>
                <IconButton
                    onClick={copyOrShare}
                    icon={<FontAwesomeIcon icon={faArrowUpFromBracket} />}
                />
                {listingId && <WishlistButton listingId={listingId} isHeader />}
            </HorizontalStack>
        </Box>
    )
}

function useStyles() {
    const container: StyleProps = {
        width: "100vw",
        height: "64px",
        position: "fixed",
        top: 0,
        left: 0,
        transition: "0.25s ease-in",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        boxSizing: "border-box",
        paddingRight: "16px",
        paddingLeft: "16px",
        paddingBottom: 0,
        display: { base: "flex", md: "none" },
    }

    return {
        container,
    }
}
